import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})



export class SidebarComponent implements OnInit, OnDestroy {
    private cssUrl  = 'assets/css/';
    private theme: string;
    private subscription;

    constructor(private toastr: ToastrService) { }

    ngOnInit() {

  }

    setTheme(theme: string ) {
        window.localStorage.setItem('theme', theme);
        this.theme = localStorage.getItem('theme');
        let link = document.getElementById('css-theme');
        if (link) {
            link['href'] = this.cssUrl + this.theme + '.css';
        } else {
            const node = document.createElement('link');
            node.href = this.cssUrl + this.theme + '.css'; // insert url in between quotes
            node.rel = 'stylesheet';
            node.id = 'css-theme';
            document.getElementsByTagName('head')[0].appendChild(node);
        }
        link = null;
    }


    ngOnDestroy() {
        // console.log('Unsubscribe sidebar');

        if (this.subscription != null)  {
            this.subscription.unsubscribe();
        }
    }
}
